import { z } from 'zod/v4';
export const WPSessionSchema = z.object({
    wp_user_id: z.number().int().nonnegative(),
    wp_email: z.string().email(),
    wp_display_name: z.string().min(1),
    wp_role: z.string().min(1),
    nonce: z.string().min(1),
    logged_in: z.boolean(),
    capabilities: z.array(z.string().min(1)),
    expires_at: z.string().min(1).nullable(),
});
export const WPBridgeConfigSchema = z.object({
    plugin_version: z.string().min(1),
    rest_base: z.string().min(1),
    plugin_url: z.string().min(1),
    asset_base: z.string().min(1),
    pwa_enabled: z.boolean(),
    feature_flags: z.record(z.string(), z.boolean()),
});
// App shell bootstrap is intentionally separate from raw WP REST DTOs.
export const FeatureFlagsSchema = z.object({
    pwaEnabled: z.boolean(),
    hostedLlmEnabled: z.boolean(),
    localLmStudioEnabled: z.boolean(),
    symbolicFallbackEnabled: z.boolean(),
});
export const UserSessionSchema = z.object({
    isLoggedIn: z.boolean(),
    wpUserId: z.number().int().nonnegative().optional(),
    displayName: z.string().min(1).optional(),
    role: z.string().min(1).optional(),
    nonce: z.string(),
});
export const AppBootstrapConfigSchema = z.object({
    restBase: z.string().min(1),
    nonce: z.string(),
    currentUser: UserSessionSchema,
    featureFlags: FeatureFlagsSchema,
    llmCapabilities: z.object({
        currentProvider: z.enum(['hosted-mini', 'external-api', 'lm-studio-local', 'symbolic-only']),
        providers: z.array(z.enum(['hosted-mini', 'external-api', 'lm-studio-local', 'symbolic-only'])),
    }),
    appVersion: z.string().min(1),
    pluginUrl: z.string().min(1),
    assetBase: z.string().min(1),
    pwaEnabled: z.boolean(),
});
//# sourceMappingURL=wp.schema.js.map